import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslateLoader } from '@cfp/core';
import { Link } from '@cfp/ui/common';
import { Card } from '@cfp/ui/layout';
import { TranslateModule } from '@ngx-translate/core';
import { map } from 'rxjs';
import { BSAT_REGISTRATION_CLOSED_REDIRECT_URL } from '../bsat-registration-closed';

@Component({
  selector: 'cfp-self-onboarding-registration-closed',
  templateUrl: './self-onboarding-registration-closed.html',
  imports: [Card, Link, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelfOnboardingRegistrationClosed {
  protected readonly redirectUrl = BSAT_REGISTRATION_CLOSED_REDIRECT_URL;

  private readonly translateLoader = inject(TranslateLoader);
  protected readonly isTranslationLoaded = toSignal(
    this.translateLoader.loadTranslation('self-onboarding').pipe(map(() => true))
  );
}
